/**
 * Breadcrumbs components.
 * @module components/theme/Breadcrumbs/Breadcrumbs
 */

import { Breadcrumb, BreadcrumbItem, Col, Row } from 'design-react-kit/dist/design-react-kit';
import React, { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { flattenToAppURL, getBaseUrl } from '@plone/volto/helpers';
import { useDispatch, useSelector } from 'react-redux';

import GoogleBreadcrumbs from '@arpav/components/ArpavTheme/Breadcrumbs/GoogleBreadcrumbs';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';
import { getBreadcrumbs } from '@plone/volto/actions';
import { isEqual } from 'lodash';

const messages = defineMessages({
  home: {
    id: 'Home',
    defaultMessage: 'Home',
  },
});

const Breadcrumbs = ({ pathname }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  let items = useSelector(state => state.breadcrumbs.items, isEqual);
  const subsite = useSelector(state => state.subsite?.data);

  useEffect(() => {
    dispatch(getBreadcrumbs(getBaseUrl(pathname)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  if (subsite) {
    //se siamo nella root di un sottosito, non mostriamo le breadcrumbs. Serve anche per nasconderle dalla pagina dei risultati di ricerca quando si fa la ricerca in un sottosito
    if (items.length === 1 && items[0].url === flattenToAppURL(subsite['@id'])) {
      items = [];
    }
  }

  return items?.length > 0 ? (
    <>
      <GoogleBreadcrumbs items={items} />
      <Row>
        <Col>
          <nav className="breadcrumb-container">
            <Breadcrumb aria-label="breadcrumb" listTag="ol" tag="nav">
              <BreadcrumbItem tag="li">
                <UniversalLink href="/">{intl.formatMessage(messages.home)}</UniversalLink>
                <span className="separator">/</span>
              </BreadcrumbItem>
              {items.map((item, index, items) => (
                <BreadcrumbItem tag="li" key={item.url} active={index == items.length - 1}>
                  {index < items.length - 1 ? (
                    <>
                      <UniversalLink href={item.url}>{item.title}</UniversalLink>
                      <span className="separator">/</span>
                    </>
                  ) : (
                    <span>{item.title}</span>
                  )}
                </BreadcrumbItem>
              ))}
            </Breadcrumb>
          </nav>
        </Col>
      </Row>
    </>
  ) : null;
};

Breadcrumbs.propTypes = {
  pathname: PropTypes.string.isRequired,
};

export default Breadcrumbs;
